module.exports = __webpack_public_path__ + "img/corethings_light_theme_1200_text_thicker.d074ce71.png";